import React, { useState, useContext, useEffect } from 'react'
import Lottie from 'react-lottie'
import queryString from 'query-string'
import { Button } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { handleRedirectInternal } from '../../product/common/components'
import PayContext from '../../product/context/payment/payContext'
import AuthContext from '../../product/context/auth/authContext'
import animationData from '../../assets/lottie/paymentAnimation.json'
import successAnimation from '../../assets/lottie/successAnimation.json'
import failureAnimation from '../../assets/lottie/failureAnimation.json'
import CustomDialog from '../../custom/components/organisms/Dialog'
import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import JustContext from '@/product/context/payment/justgiving/justContext'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import './Checkout.css'

const PaymentSuccess = (props) => {
    const authContext = useContext(AuthContext)
    const payContext = useContext(PayContext)

    const [paymentResponse, setPaymentResponse] = useState(null)
    const invoiceContext = useContext(InvoiceContext)
    const { getAllUserInvoices } = invoiceContext
    const {
        payCartStripeResponse,
        responseStatus: responseStatusPayment,
        clearResponse: clearResponsePayment,
    } = payContext
    const justContext = useContext(JustContext)
    const {
        payCart,
        payCartResponse,
        responseStatus: responseStatusJustPayment,
        clearResponse: clearResponseJustPayment,
    } = justContext

    const [toggleDialogDeposit, setToggleDialogDeposit] = useState(false)

    const changeDialogStatusDeposit = () => {
        setToggleDialogDeposit(!toggleDialogDeposit)
    }

    const { isAuthenticated, loadUser, user } = authContext
    const history = useHistory()
    // const {
    //     responseCartPayTm,
    //     responseStatus: responseStatusPayment,
    //     clearResponse: clearResponsePayment,
    // } = payContext

    useEffect(() => {
        if (props.location.search) {
            const response = queryString.parse(props.location.search)
            setPaymentResponse(null)
            // response.additional_buynow_data = {
            //     justPaySuccess: 0,
            //     stripePaySuccess: 1,
            // }
            // response.additional_buynow_update = true
            response.stripeSuccess = true
            response.email_tigger = true
            console.log(response, 'what response')
            let formData = localStorage.getItem('plandata')
            if (formData) {
                formData = JSON.parse(formData)
                response.pay_type = formData.pay_type
                response.payment_object = formData.payment_object
                response.period = formData.period
                payCartStripeResponse(response)
                localStorage.removeItem('plandata')
            } else {
                payCartStripeResponse(response)
            }

            history.replace({
                search: '',
            })
        }
    }, [props.location.search])

    // useEffect(() => {
    //     if (responseStatusPayment) {
    //         if (responseStatusPayment.from === 'paytmResponse') {
    //             setPaymentResponse(responseStatusPayment)
    //             clearResponsePayment()
    //             setToggleDialogDeposit(true)
    //             loadUser()
    //         }
    //     }
    // }, [responseStatusPayment])

    const defaultOptions = {
        loop: true,
        autoplay: true,
        speed: '0.25',
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    }

    const paymentSuccessOptions = {
        loop: true,
        autoplay: true,
        speed: '0.25',
        animationData: successAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    }

    const paymentFailureOptions = {
        loop: true,
        autoplay: true,
        speed: '0.25',
        animationData: failureAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    }

    useEffect(() => {
        if (responseStatusPayment) {
            if (responseStatusPayment.from === 'payment_response') {
                console.log(responseStatusPayment, 'responseStatusPayment')
                setPaymentResponse(responseStatusPayment)

                if (
                    responseStatusPayment.status == 'success' &&
                    responseStatusPayment?.data?.pay_type !== 'membership_payment'
                ) {
                    let formData = localStorage.getItem('paydata')
                    if (formData) {
                        formData = JSON.parse(formData)
                        console.log(formData, 'formDatat')
                        if (formData.cart_id && !formData.invoice_id) {
                            payCart(formData)
                        }
                        localStorage.removeItem('paydata')
                        // setToggleDialogDeposit(true)
                    } else {
                        setToggleDialogDeposit(true)
                    }
                } else {
                    redirectFunction(responseStatusPayment)
                }
                clearResponsePayment()
            }
        }
    }, [responseStatusPayment])

    useEffect(() => {
        if (responseStatusJustPayment) {
            console.log('responseStatusPayment', responseStatusJustPayment)

            if (responseStatusJustPayment.from === 'payment') {
                console.log('Setting ID', responseStatusJustPayment.data)

                if (
                    responseStatusJustPayment.status === 'success' ||
                    responseStatusJustPayment.status === 'COMPLETED'
                ) {
                    var html = responseStatusJustPayment.data.result
                    // var html = `${html_content}`
                    // html = html.replaceAll('\\"', '"')

                    window.open(html, '_self')
                    // window.location.href = html
                    setTimeout(() => {
                        setIsLoading(false)
                    }, 2000)

                    // handleRedirectInternal(history, 'search')
                } else {
                    setIsLoading(false)

                    setAlert(responseStatusJustPayment.message, responseStatusJustPayment.status)
                }
            }
        }
        return () => {
            clearResponseJustPayment()
        }
    }, [responseStatusJustPayment])

    const redirectFunction = (data) => {
        console.log(data, 'data after redirect')

        if (data?.status && data.status === 'success') {
            if (data?.data?.pay_type == 'membership_payment') {
                loadUser()
                if (!user?.seniority || user?.seniority == null) {
                    handleRedirectInternal(history, 'account/profile')
                } else {
                    handleRedirectInternal(history, 'payments/subscription')
                }
            } else {
                handleRedirectInternal(history, 'invoices/all')
            }
        } else if (data?.data?.pay_type == 'membership_payment') {
            loadUser()
            if (!user?.seniority) {
                handleRedirectInternal(history, 'account/profile')
            } else {
                handleRedirectInternal(history, 'subscription')
            }
        } else if (data?.to == 'membership_payment' && data.status === 'error') {
            loadUser()
            handleRedirectInternal(history, 'subscription')
        } else {
            console.log('iiiiiippppp')
            const redirectPage = data?.data?.to === 'buynow' ? 'invoices/all' : 'singlecart'

            handleRedirectInternal(history, redirectPage)
        }
    }

    useEffect(() => {
        if (paymentResponse?.status === 'success') {
            getAllUserInvoices(
                {
                    limit: 10,
                    page: 1,
                    checkout: 1,
                    // admin: 1,
                    action: 'allunpaid',
                    filters: {
                        active: {
                            value: '2',
                            type: 'notin',
                            field: 'b.active',
                        },
                        action: {
                            value: '',
                            type: 'in',
                            field: 'b.paid',
                        },
                    },
                },
                'userUnpaidInvoice',
            )
        }
    }, [paymentResponse])

    return (
        <div className="container">
            <div className="paymentResponse lottie-container">
                <Lottie options={defaultOptions} speed="0.25" height={300} width={400} />
                <h2>{'Hang in there your payment is being processed'}</h2>
                <h4>{'Please do not press the back button or refresh the page'}</h4>
            </div>
            {paymentResponse && paymentResponse.status ? (
                <CustomDialog
                    title="Payment Status"
                    disableBackdropClick
                    open={toggleDialogDeposit}
                    className="paymentNotifCnt"
                    function={changeDialogStatusDeposit}
                >
                    {paymentResponse.status === 'success' ? (
                        <div className="paymentNotif">
                            <Lottie
                                options={paymentSuccessOptions}
                                speed="0.25"
                                height="auto"
                                width={200}
                            />
                            <div className="paymentContent">
                                <div className="paymentCheckSuccess">
                                    <span className="material-icons-outlined ico">
                                        check_circle
                                    </span>
                                    <h4>Payment Success!</h4>
                                </div>
                                {/* <h5>
                                    You have successfully made a purchase of{' '}
                                    {currencyFormat(rosoomResponse.serviceCost)}.
                                </h5> */}
                                <PrimaryButton
                                    btnSize="small"
                                    onClick={() => {
                                        getAllUserInvoices(
                                            {
                                                limit: 10,
                                                page: 1,
                                                checkout: 1,
                                                // admin: 1,
                                                action: 'allunpaid',
                                                filters: {
                                                    active: {
                                                        value: '2',
                                                        type: 'notin',
                                                        field: 'b.active',
                                                    },
                                                    action: {
                                                        value: '',
                                                        type: 'in',
                                                        field: 'b.paid',
                                                    },
                                                },
                                            },
                                            'userUnpaidInvoice',
                                        )
                                        redirectFunction(paymentResponse)
                                    }}
                                >
                                    Continue
                                </PrimaryButton>
                            </div>
                        </div>
                    ) : (
                        <div className="paymentNotif failure">
                            <Lottie
                                options={paymentFailureOptions}
                                speed="0.25"
                                height="auto"
                                width={200}
                            />
                            <div className="paymentContent">
                                <span className="material-icons-outlined ico">
                                    report_gmailerrorred
                                </span>
                                <h4>Payment Failed</h4>
                                {/* <h5>{paymentResponse.message ? paymentResponse.message : ''}</h5> */}
                                <PrimaryButton btnSize="small" onClick={() => redirectFunction()}>
                                    Try Again
                                </PrimaryButton>
                            </div>
                        </div>
                    )}
                </CustomDialog>
            ) : null}
        </div>
    )
}

export default PaymentSuccess
